import { c as _c } from "react/compiler-runtime";
/*
 MIGRATION NOTE: The following Chakra UI hooks have been removed.
 Please replace them with the suggested alternatives:

//   - useBoolean: Use react-use: useToggle or useState

 See: https://chakra-ui.com/docs/get-started/migration#hooks
*/
import { AspectRatio, Box, Flex, Icon, IconButton, Image } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { useEffect, useRef, useState } from 'react';
import { MdPlayArrow } from 'react-icons/md';
import { useInView } from 'react-intersection-observer';
import ReactPlayer from 'react-player';
interface VideoSwapProps {
  cardTitle?: string;
  description?: string;
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  bgColor?: string;
  bgGradient?: string;
  btnColor?: string;
  btnCTA?: string;
  btnHref?: string;
  boxShadow?: string;
  videoUrl: string;
  coverImage: string;
}
const VideoSwap: React.FC<VideoSwapProps> = t0 => {
  const $ = _c(14);
  const {
    direction: t1,
    coverImage,
    videoUrl
  } = t0;
  t1 === undefined ? "row" : t1;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const [isExpanded, setIsExpanded] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      threshold: 0.25,
      triggerOnce: false
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    ref,
    inView
  } = useInView(t2);
  const previewVideoRef = useRef(null);
  let t3;
  let t4;
  if ($[1] !== inView || $[2] !== isExpanded) {
    t3 = () => {
      const video = previewVideoRef.current;
      if (!video) {
        return;
      }
      if (inView && !isExpanded) {
        video.play().catch(_temp);
      } else {
        video.pause();
      }
    };
    t4 = [inView, isExpanded];
    $[1] = inView;
    $[2] = isExpanded;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== coverImage || $[6] !== getBreakpointValue || $[7] !== inView || $[8] !== isExpanded || $[9] !== videoUrl) {
    t5 = !isExpanded ? <Flex height="full" position="relative" width="full"><Flex align="center" justify={getBreakpointValue(["center", "flex-start"])} width="full" zIndex={5}><Image borderRadius="2xl" style={{
          filter: "drop-shadow(0px 12px 8px rgba(0, 0, 0, 0.5))"
        }} width={getBreakpointValue(["100%", "100%"])} alt="Presentation Slide" src={coverImage} /></Flex><Flex align="center" bottom={getBreakpointValue(["-5", "-5"])} height={getBreakpointValue(["120px", "200px"])} justify="center" overflow="hidden" position="absolute" right={getBreakpointValue(["0", "-5"])} rounded="full" style={{
        filter: "drop-shadow(0px 12px 8px rgba(0, 0, 0, 0.3))"
      }} width={getBreakpointValue(["120px", "200px"])} zIndex={6}><Box h="full" overflow="hidden" position="relative" rounded="full" w="full"><video ref={previewVideoRef} loop={true} muted={true} playsInline={true} height="100%" src="https://s3.amazonaws.com/app-assets.startups.com/static/videos/ed-trimmed-2.mp4" style={{
            objectFit: "cover",
            width: "100%",
            height: "100%",
            borderRadius: "50%"
          }} width="100%" /></Box></Flex><Box bottom={0} left={0} margin={6} position="absolute" right={0} zIndex={7}><IconButton aria-label="Play" bgColor="orange.600" boxShadow="0px 0px 5px 5px rgba(0, 0, 0, 0.2)" color="white" height={getBreakpointValue(["4em", "6em"])} width={getBreakpointValue(["4em", "6em"])} _hover={{
          boxShadow: "0px 0px 20px 5px rgba(0, 0, 0, 0.5)"
        }} rounded="full" onClick={() => setIsExpanded(_temp2)}><Icon asChild={true} boxSize={getBreakpointValue([6, 12])}><MdPlayArrow /></Icon></IconButton></Box></Flex> : <AspectRatio borderRadius="xl" boxShadow="lg" flex={2} overflow="hidden" ratio={1.7777777777777777} width="full"><ReactPlayer controls={true} height="100%" light={false} pip={true} playing={inView} url={videoUrl} width="100%" config={{
        vimeo: {
          playerOptions: {
            badge: 0,
            autopause: 0,
            player_id: 0,
            app_id: 58479
          }
        }
      }} /></AspectRatio>;
    $[5] = coverImage;
    $[6] = getBreakpointValue;
    $[7] = inView;
    $[8] = isExpanded;
    $[9] = videoUrl;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== ref || $[12] !== t5) {
    t6 = <Flex ref={ref} align="center" flex={2} justify="center" width="full" position="relative" paddingBottom={5}>{t5}</Flex>;
    $[11] = ref;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default VideoSwap;
function _temp() {}
function _temp2(prev) {
  return !prev;
}